import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SignComponent } from './sign.component';
import { SignListComponent } from './list/sign-list.component';
import { AppRoutingModule } from '../app.routes';
import { ClipboardModule } from 'ngx-clipboard';
// import { PosterModule } from '../poster/poster.module';
import { CommonModule } from '../common/common.module';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule,  AppRoutingModule, CommonModule, ClipboardModule],
    declarations: [SignListComponent, SignComponent],
    exports: [ClipboardModule]
})
export class SignModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/sign/sign.module.ts